var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.result === 'Passed')?_c('el-tag',{attrs:{"size":"mini","type":"success"}},[_vm._v("已通过")]):(_vm.result === 'Fail')?_c('el-tag',{attrs:{"size":"mini","type":"danger"}},[_vm._v("未通过")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }